const SessionsSearchIcon = ({ className = "" }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.8333 7.5V5.83333H13.3333V2.5H15V5.83333H17.5V7.5H10.8333ZM13.3333 17.5V9.16667H15V17.5H13.3333ZM5 17.5V14.1667H2.5V12.5H9.16667V14.1667H6.66667V17.5H5ZM5 10.8333V2.5H6.66667V10.8333H5Z"
        fill="white"
      />
    </svg>
  );
};

export default SessionsSearchIcon;
